export async function apiCampaignsList(request, args) {
  //console.log(args);
    const list = await request({
        url: "/campaigns",
        method: "get",
        params: args
      });
    return list;
}

export async function apiCampaignDetail(request, uuid) {
  const detail = await request({
    url: "/campaigns/" + uuid,
    method: "get",
    params: { no_count: 1}
  });
  return detail;
}

export async function apiCampaignLocations(request, uuid, loc) {
  const locations = await request({
    url: "/campaigns/" + uuid + "/locations",
    method: "get",
    params: { lat: loc.lat, lng: loc.lng }
  });
  return locations;
}
